module.exports = {
    "dismiss": `Luk`
};


//# sourceMappingURL=da-DK.main.js.map
